import { Fetch } from "@syncfusion/ej2-base";
import {
  CrudOptions,
  DataOptions,
  DataResult,
  Query,
} from "@syncfusion/ej2-data";
import {
  ODataV4QueryStringAndMaybeHeadersFactory,
  ODataV4TransformDataMethod,
} from "../../../../stores/OData/types";
import BaseODataV4Adaptor from "../../../../stores/OData/BaseODataV4Adaptor";

export default class AsyncMultiSelectODataV4Adaptor<
  TData = any
> extends BaseODataV4Adaptor<TData> {
  constructor(
    private groupbyActiveStatus: boolean,
    beforeSendFn?: ODataV4QueryStringAndMaybeHeadersFactory,
    transformData?: ODataV4TransformDataMethod<TData>,
    removeLeadingQuestionMark: boolean = true,
    replaceUndefinedInQueryStringWithNulls: boolean = true,
    removeUnsupportedParameters: boolean = true
  ) {
    super({
      beforeSendFn,
      transformData,
      removeLeadingQuestionMark,
      replaceUndefinedInQueryStringWithNulls,
      removeUnsupportedParameters,
    });
  }

  processResponse(
    data: DataResult,
    ds?: DataOptions,
    query?: Query,
    xhr?: Request,
    request?: Fetch,
    changes?: CrudOptions
  ): Object {
    const processResult = super.processResponse.apply(this, [
      data,
      ds,
      query,
      xhr,
      request,
      changes,
    ]);

    if (this.groupbyActiveStatus) {
      const processResultActive = (processResult as Array<any>)
        .filter((x) => !x.isDeleted)
        .map((x) => {
          return {
            ...x,
            ...{ category: "Active" },
          };
        });

      const processResultInactive = (processResult as Array<any>)
        .filter((x) => x.isDeleted)
        .map((x) => {
          return {
            ...x,
            ...{ category: "Inactive" },
          };
        });

      return [
        ...(processResultActive as any),
        ...(processResultInactive as any),
      ];
    }

    return processResult;
  }
}
